/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Allow_ProxiesInputs */



/**
* | output |
* | --- |
* | "Allow Proxies" |
*
* @param {Og_Cfg_Allow_ProxiesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_allow_proxies = /** @type {((inputs?: Og_Cfg_Allow_ProxiesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Allow_ProxiesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autoriser les proxies")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permitir proxies")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Permitir Proxies")
	if (locale === "it") return /** @type {LocalizedString} */ ("Permetti Proxy")
	return /** @type {LocalizedString} */ ("Allow Proxies")
});